import { ApiRequest, putItem, postItem, deleteItem } from "utils/ApiUtils"
import buildQuery from 'odata-query';
import ODataUtil from './ODataUtil';
import { WorkItem } from 'classes';

const workitem_endpoint = "/WorkItem";

async function getWorkItems(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const model = WorkItem;
  const endpoint = workitem_endpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, {model, endpoint});
  return data;
};

async function getWorkItem(workItemNum) {
  const filter = { "WorkItemNumber": workItemNum };
  const params = buildQuery({ filter, expand: WorkItem.expand });
  const data = await ApiRequest(workitem_endpoint, params);
  const item = data.value[0];
  const workitem = new WorkItem(item);
  workitem.Description_WorkItemsStatus = item.WorkItemsStatus.Description
  workitem.Description_Witype = item.Witype.Description
  delete workitem.Delete
  delete workitem.Edit
  return workitem
}

async function getWorkItemType() {
  const params = ""
  const response = await ApiRequest('/Domain?domainName=LuWorkItemType&includeReserved=false', params)
  return response.data
}

async function addWorkItem(projectId, data) {
  const resourcePath = `${workitem_endpoint}/Add`
  const params = `?projectId=${projectId}`
  data.ProjectId = projectId
  const result = await postItem(resourcePath, params, data, false, true)
  return result
}

async function importWorkItem(data) {
  const resourcePath = `${workitem_endpoint}/ImportWorkItems`
  const params = ''
  const result = await postItem(resourcePath, params, data, false, true)
  return result
}

async function updateWorkItem(projectId, formData, data) {
  const resourcePath = `${workitem_endpoint}/Edit`
  formData.WorkItemId = data.WorkItemId
  formData.ProjectId = projectId
  const params = `?projectId=${projectId}`
  const result = await putItem(resourcePath, params, formData, true)
  return result
}

async function deleteWorkItem(projectId, workitem) {
  const resourcePath = `${workitem_endpoint}/Delete`
   //TODO:
   const result = await deleteItem(resourcePath, '', workitem)
  return result
}


async function uploadWorkItems(value, projectId) {
  const resourcePath = `${workitem_endpoint}/uploadexcel`
  const params = `?projectId=${projectId}`
  const result = await postItem(resourcePath, params, value, true, false)
  return result
}


export { WorkItem, getWorkItems, addWorkItem, updateWorkItem, deleteWorkItem, uploadWorkItems, getWorkItemType, importWorkItem,getWorkItem }